// https://github.com/pixijs/pixijs/blob/559e3df8de62740b9099532a9c4d3f6701829de4/packages/utils/src/browser/isWebGLSupported.ts
let supported: boolean | undefined;
export const isWebGLSupported = (): boolean => {
  if (typeof supported === 'undefined') {
    supported = (function supported(): boolean {
      const contextOptions = {
        stencil: true,
        failIfMajorPerformanceCaveat: true,
      };

      try {
        const canvas = document.createElement('canvas');
        let gl = (canvas.getContext('webgl', contextOptions) ||
          canvas.getContext('experimental-webgl', contextOptions)) as WebGLRenderingContext;

        const success = !!(gl && gl.getContextAttributes().stencil);

        if (gl) {
          const loseContext = gl.getExtension('WEBGL_lose_context');

          if (loseContext) {
            loseContext.loseContext();
          }
        }

        gl = null;

        return success;
      } catch (e) {
        return false;
      }
    })();
  }

  return supported;
};
